import React from "react";
import { Switch } from "react-router-dom";
import { useHistory, useLocation } from "react-router";

import PrivateRoute from "./routes/PrivateRoute";
import CurrentRoute from "./routes/CurrentRoute";
import AdminRoute from "./routes/AdminRoute";
import ProfileProvider from "./reducers/ProfileProvider";

import Home from "./views/Home";
import Auth from "./views/Auth";
import Main from "./views/Main";
import Results from "./views/Results";
import Test from "./views/Test";
import Finish from "./views/Finish";
import Header from "./components/Header";
import Heading from "./components/Heading";
import Juries from "./views/Juries";
import JuriesCard from "./views/JuriesCard";

export default () => {
  const { pathname } = useLocation();
  const history = useHistory();

  const RenderHeading = () => {
    const backHome = () => history.push("/");

    if (pathname === "/" || pathname === "/auth") {
      return <Heading backHome={backHome} isNotHome={pathname !== "/"} />;
    }

    return null;
  };

  return (
    <ProfileProvider>
      <Header />
      <RenderHeading />
      <Switch>
        <CurrentRoute path="/" exact>
          <Home />
        </CurrentRoute>
        <CurrentRoute path="/auth">
          <Auth />
        </CurrentRoute>
        <AdminRoute path="/juries" exact>
          <Juries />
        </AdminRoute>
        <AdminRoute path="/juries/:juries_id">
          <JuriesCard />
        </AdminRoute>
        <AdminRoute path="/results">
          <Results />
        </AdminRoute>
        <Main>
          <PrivateRoute path="/finalists" exact>
            <Finish />
          </PrivateRoute>
          <PrivateRoute path="/finalists/:finalists_id">
            <Test />
          </PrivateRoute>
        </Main>
      </Switch>
    </ProfileProvider>
  );
};
